module.exports = __webpack_public_path__ + "static/media/as_item3_bg.ccfee3b3.png";